(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["como-funciona"] && !Shopify.designMode) return;
  try {
    
/* Optional: add simple animation on intersection */
(function(){
  var root = document.getElementById('como-funciona-{{ section.id }}');
  if(!root || !('IntersectionObserver' in window)) return;
  var items = root.querySelectorAll('.cf-step');
  items.forEach(function(el){ el.style.opacity = 0; el.style.transform = 'translateY(8px)'; });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.style.transition = 'opacity .4s ease, transform .4s ease';
        entry.target.style.opacity = 1; entry.target.style.transform = 'translateY(0)';
        io.unobserve(entry.target);
      }
    })
  }, { threshold: 0.15 });
  items.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
